<template>
    <div class="proDetail content-part">
        <div class="banner">
            <img src="https://0.rc.xiniu.com/g2/M00/FD/18/CgAGfFv7WCKAaIF2AAEra7lHQmQ157.jpg">
        </div>
        <div class="main">
            <div class="main-content">
                <div v-html='content'></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            id:'',
            content:''
        }
    },
    mounted(){
        if(this.$route.query.id){
            this.id=this.$route.query.id
            this.getDetail()
        }else{
            this.$router.push('/product')
        }
    },
    methods:{
        getDetail(){
            this.$http.get('/api/portal/product/query',{
                params:{
                    id:this.id
                }
            }).then((res)=>{
                // console.log(res)
                this.content=res.data&&res.data.content?res.data.content:''
            })
        },
    }
}
</script>

<style lang="less">
.proDetail{
    background: rgb(247, 247, 247);
    .main{
        .main-content{
            box-sizing: border-box;
            padding: 100px 0 60px;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/view/proDetail.vue